export function transitionEndListener(node: HTMLElement, done: () => void): void {
    node.addEventListener('transitionend', done, false);
    node.addEventListener('animationend', done, false);
}
